export default "__VITE_ASSET__tXxdJ56w__"